<template>
  <b-navbar
    v-if="clientInfo"
    toggleable="lg"
    type="light"
    variant="light"
    fixed="top"
    ref="topNavbar"
    id="top-navbar"
  >
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-navbar-nav class="d-md-none">
      <cart-status v-if="clientInfo"/>
    </b-navbar-nav>

    <b-navbar-brand :href="homeUrl">
      <b-img
        class="logo"
        :src="clientInfo.logo"
        :alt="clientInfo.name" />
    </b-navbar-brand>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item :href="homeUrl">Inicio</b-nav-item>
        <b-nav-item-dropdown
          v-if="categories.length > 0"
          :text="translation('categories')"
          class="my-shadow"
          right
        >
          <b-dropdown-item
            v-for="(category, idx) of categories"
            :key="idx"
            :href="fullUrl(category.url)"
          >
            {{ category.name }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item v-if="adsCount.marketplace > 0" :to="`/ads-list/${client}`">Marketplace</b-nav-item>
        <b-nav-item v-if="adsCount.gifts > 0" :to="`/gifts-list/${client}`">Regalos</b-nav-item>
        <b-nav-item v-if="adsCount.vouchers > 0" :to="`/vouchers/${client}`">Solicitudes</b-nav-item>
        <b-nav-item v-if="adsCount.info > 0" :to="`/info/${client}`">Información</b-nav-item>
        <b-nav-item-dropdown
          v-if="languages.length > 1"
          :text="language.toUpperCase()"
          class="my-shadow"
          right
        >
          <b-dropdown-item
            v-for="(language, idx) of languages"
            :key="idx"
            href="#"
            @click="changeLanguage(language.value)"
          >
            {{ language.label }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item
          v-if="isReceptionManager || isReception"
          :to="`/client-home/${client}`"
        >
          Area de empresa
        </b-nav-item>
        <b-nav-item
          v-if="isUser"
          :to="`/user-home/${client}`"
        >
          Area de usuario
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav>
        <form :action="submitUrl" id="general-search-form" class="form-inline my-2 my-lg-0">
          <b-input-group>
            <b-form-input name="filter"></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-success"><font-awesome-icon class="mt-1" icon="search"/></b-button>
            </b-input-group-append>
          </b-input-group>
          <input name="id_client" type="hidden" class="form-control" :value="client">
          <input name="in_search" type="hidden" value="1">
        </form>
        <cart-status v-if="clientInfo"/>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CartStatus from '@/components/cart/CartStatus'

export default {
  name: 'TopNavbar',
  components: { CartStatus },
  computed: {
    ...mapGetters('auth', ['isUser', 'isReceptionManager', 'isReception']),
    ...mapGetters(['language', 'translation', 'fullUrl']),
    ...mapGetters('clients', ['client', 'clientInfo', 'categories', 'languages']),
    ...mapGetters('ads', ['adsCount']),
    ...mapGetters(['homeUrl']),
    submitUrl () {
      return `sponsor/view/${this.client}`
    }
  },
  methods: {
    ...mapActions(['setNavbarHeight', 'routeReload', 'setLanguage']),
    ...mapActions('clients', ['initClient', 'setHomeActive', 'resetClientInfo']),
    openClientHome (page) {
      this.setHomeActive(page)
      const path = `/client-home/${this.client}`
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path)
      }
    },
    changeLanguage (language) {
      this.setLanguage(language)
      this.resetClientInfo()
      this.initClient(this.client)
        .then(() => {
          this.routeReload()
        })
    }
  },
  mounted () {
    // const obj = this
    /* setTimeout(() => {
      obj.setNavbarHeight(obj.$refs.topNavbar.clientHeight)
    }, 500) */
  }
}
</script>

<style lang="scss" scoped>
  .logo {
    max-height: 40px;
  }
</style>
